
let eventGuid = 0
let todayStr = new Date().toISOString().replace(/T.*$/, '') // YYYY-MM-DD of today

console.log('DFFFFFFFF: '+todayStr);
export const INITIAL_EVENTS = [
  {
    id: createEventId(),
    title: 'All-day event',
    start: '2022-09-21'
  },
  {
    id: createEventId(),
    title: 'Timed event',
    start: '2022-09-25',
    end: '2022-09-26',
  }
]

export function createEventId() {
  return String(eventGuid++)
}